/* =========================================================================
   TimeFrameSupply - footer accordion
   Native <details> on mobile, permanently open and non-interactive on
   desktop. Registered once; multiple instances are safe.
   ========================================================================= */

class TfsFooterAccordion extends HTMLElement {
  connectedCallback() {
    this.panels = Array.prototype.slice.call(this.querySelectorAll('details'));
    if (!this.panels.length) return;

    this.mq = window.matchMedia('(min-width: 750px)');
    this.sync = this.sync.bind(this);
    this.sync();

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.sync);
    } else if (this.mq.addListener) {
      this.mq.addListener(this.sync);
    }
  }

  sync() {
    var wide = this.mq.matches;
    this.panels.forEach(function (panel) {
      var summary = panel.querySelector('summary');
      if (wide) {
        panel.open = true;
        panel.setAttribute('data-locked', 'true');
        if (summary) {
          summary.setAttribute('tabindex', '-1');
          summary.setAttribute('aria-hidden', 'false');
        }
      } else {
        panel.removeAttribute('data-locked');
        panel.open = false;
        if (summary) summary.removeAttribute('tabindex');
      }
    });
  }
}

if (!customElements.get('tfs-footer-accordion')) {
  customElements.define('tfs-footer-accordion', TfsFooterAccordion);
}
